import { Chip, Tooltip, useTheme } from '@mui/material';

interface ITagChipProps {
  title: string;
  onDelete: () => void;
  disabled?: boolean;
}

const TagChip: React.FC<ITagChipProps> = ({ title, onDelete, disabled }) => {
  const theme = useTheme();
  return (
    <Tooltip title={title} open={title.length <= 28 ? false : undefined}>
      <Chip
        variant={'outlined'}
        label={title}
        size={'small'}
        onDelete={onDelete}
        disabled={disabled}
        sx={{
          border: 'none',
          maxWidth: '300px',
          fontSize: '14px',
          lineHeight: '21px',
          backgroundColor: theme.custom.palette.primary.default,
          color: theme.custom.palette.primary.white,

          '& .MuiChip-deleteIcon': {
            color: theme.custom.palette.primary.white,

            '&:hover': {
              color: 'inherit',
            },
          },
        }}
      />
    </Tooltip>
  );
};

export default TagChip;
